// Resalta, dentro del tooltip de `trigger:"axis"`, la fila de la serie que está
// bajo el cursor. ECharts NO le pasa al formatter cuál serie se está hovereando
// (el tooltip de eje lista todas), así que la trackeamos con los eventos
// `chart-mouseover`/`chart-mouseout` que reenvía EChart.vue y el formatter
// consulta `hoveredSeriesName`.
//
// `hoveredSeriesName` vive en data pero NO se referencia en la computed del
// `option`: el formatter (una función creada dentro de esa computed pero no
// invocada al evaluarla) lo lee en vivo cuando ECharts lo reinvoca al mover el
// puntero, así que cambiarlo no recomputa ni re-renderiza el chart entero —
// sólo cambia qué fila sale en bold. Cada chart de eje liga
// `@chart-mouseover="onSeriesHover" @chart-mouseout="onSeriesOut"` y aplica
// `focusRowStyle(p.seriesName)` al estilo de cada fila del tooltip.
export const FOCUS_ROW_STYLE =
    "font-weight:700;background:rgba(255,255,255,0.12);border-radius:4px;padding:1px 6px;margin:0 -6px;";

export default {
    data() {
        return { hoveredSeriesName: null };
    },
    methods: {
        onSeriesHover(params) {
            if (params && params.seriesName) this.hoveredSeriesName = params.seriesName;
        },
        onSeriesOut(params) {
            // Sólo limpiamos al salir de la serie actualmente resaltada — entre
            // segmentos, el mouseover de la nueva ya actualizó el nombre y no
            // queremos que un mouseout tardío de la anterior lo borre.
            if (!params || params.seriesName === this.hoveredSeriesName) {
                this.hoveredSeriesName = null;
            }
        },
        // Estilo extra para la fila de la serie focuseada (bold + fondo sutil).
        // "" cuando no hay foco o no es esta serie.
        focusRowStyle(seriesName) {
            return seriesName === this.hoveredSeriesName ? FOCUS_ROW_STYLE : "";
        },
    },
};
